import styled from "@emotion/styled";

import { fontRobotoCondensed, theme } from "shared/lib/styles";

import { AuthorAvatar } from "scmp-app/components/author/author-avatar";
import { EntityLink } from "scmp-app/components/entity-link";
import { setResponsiveHeaderFontSize } from "scmp-app/components/header/header-oneline-menu-container/header-all-menu/common/styles";

export const Container = styled.div``;

export const Title = styled.div`
  color: #001246;
  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  line-height: normal;
  ${theme.breakpoints.up("mediumDesktop")} {
    font-size: 16px;
  }
`;

export const StyledAuthorAvatar = styled(AuthorAvatar)`
  inline-size: 41px;
  block-size: 41px;
  padding: 2px;

  border-radius: 50%;

  overflow: hidden;
`;

export const AuthorName = styled.span`
  margin-inline-start: 8px;

  color: #000000;
  font-family: ${fontRobotoCondensed};
  line-height: 18px;

  ${setResponsiveHeaderFontSize()};
`;

export const StyledEntityLink = styled(EntityLink)`
  display: flex;
  flex-flow: row;
  justify-content: flex-start;
  align-items: center;
  &:hover ${AuthorName} {
    color: #2c4692;
    text-decoration: underline;
  }

  ${StyledAuthorAvatar} {
    flex: 0 0 auto;

    inline-size: 40px;
    block-size: 40px;
  }
`;

export const LinkContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
`;
